import React from 'react';
import PropTypes from 'prop-types';
import PricingDataProvider from '../components/Organization/PricingDataProvider';

const hook = ({ organizationId, ...props }) => {
  return <PricingDataProvider organizationId={organizationId} {...props} />;
};

hook.propTypes = {
  organizationId: PropTypes.number
};

hook.defaultProps = {
  organizationId: null
};

export default hook;
